import { api, extractJsonObject } from "./api";

function toJson(respData) {
  if (typeof respData === "object") return respData;
  const cleaned = extractJsonObject(respData);
  return JSON.parse(cleaned);
}

export async function fetchKendraList(mainuser) {
  const resp = await api.get("get_kendra_list.php", { params: { mainuser } });
  const j = toJson(resp.data);
  if (!j.ok) throw new Error(j.error || "Failed to load kendra list");
  return Array.isArray(j.kendra) ? j.kendra : [];
}

// local selection helpers
const KEY = "selected_kendra";

export function loadSelectedKendra() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveSelectedKendra(k) {
  localStorage.setItem(KEY, JSON.stringify(k));
}
